import DataStorePropertyDAOFactory from "../dao/datastore/DataStorePropertyDAOFactory";
import { Property } from "../../../models";
import PropertyDAO from "../dao/PropertyDAO";
import { propertyIdInFocusAtom } from "../../ui/InFocusRecoilStates";
import { propertyIdToPropertySelectorFamily } from "../state/PropertyRecoilState";
import { useRecoilCallback } from "recoil";

const propertyDao: PropertyDAO = DataStorePropertyDAOFactory.getInstance();

export const useSetUpProperty = () => {

    const setUpProperty = useRecoilCallback(({ snapshot, set }) => async (propertyId: string) => {
        const property: Property = await propertyDao.getById(propertyId);
        set(propertyIdToPropertySelectorFamily(propertyId), property);
        set(propertyIdInFocusAtom, propertyId);
    }, []);

    const resetProperty = useRecoilCallback(({ snapshot, reset }) => () => {
        const propertyId = snapshot.getLoadable(propertyIdInFocusAtom).contents;
        reset(propertyIdToPropertySelectorFamily(propertyId));
        reset(propertyIdInFocusAtom);
        //TODO: reset permissions
    }, []);

    return { setUpProperty, resetProperty };
};